import React from "react";
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend, Tooltip } from "recharts";

/* 四维度雷达：团队均分 vs 选中电销 */
export function TMQARadar({ dims, team, agent, zh }) {
  const data = (dims || []).map((d) => ({ dim: zh ? d.zh : d.en, team: team?.[d.key] ?? 0, agent: agent?.[d.key] ?? null }));
  const series = data.map((x) => x.team + (x.agent || 0));
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-3" data-testid="tm-qa-radar" data-series={series.join(",")}>
      <div className="text-sm font-medium text-slate-700 mb-1">{zh ? "维度雷达" : "Dimensions"}{agent && <span className="ml-2 text-xs font-normal text-indigo-600" data-testid="tm-qa-radar-agent">{agent.name}</span>}</div>
      <div className="h-56">
        <ResponsiveContainer width="100%" height="100%">
          <RadarChart data={data} outerRadius="72%">
            <PolarGrid stroke="#e2e8f0" />
            <PolarAngleAxis dataKey="dim" tick={{ fontSize: 11, fill: "#475569" }} />
            <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
            <Radar name={zh ? "团队均分" : "Team"} dataKey="team" stroke="#6366f1" fill="#6366f1" fillOpacity={0.25} />
            {agent && <Radar name={agent.name} dataKey="agent" stroke="#f59e0b" fill="#f59e0b" fillOpacity={0.25} />}
            <Tooltip formatter={(v) => (v == null ? "—" : v)} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
          </RadarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
